import i18n, { type AppLanguage, DEFAULT_LANGUAGE } from '@repo/i18n'
import { enUS, it, type Locale } from 'date-fns/locale'
import { format } from 'date-fns-tz'

const locales = {
	en: enUS,
	it
} as const satisfies Record<AppLanguage['code'], Locale>

export const formatLocaleDate = (date: string | Date, formatType = 'P') => {
	const currentLang = i18n.language || DEFAULT_LANGUAGE.code
	const locale =
		locales[currentLang as keyof typeof locales] ||
		locales[DEFAULT_LANGUAGE.code]
	return format(new Date(date), formatType, { locale })
}
